import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import type { DxReportPdfState } from './useDxReportPdf';

interface DxReportPdfPaneProps {
    state: DxReportPdfState;
    /** Shown on a build error, when there is an editor to go back to. */
    onBackToEdit?: () => void;
}

export function DxReportPdfPane({ state, onBackToEdit }: DxReportPdfPaneProps) {
    return (
        <div className="flex-1 min-h-0 p-5">
            <div className="h-full rounded-xl border border-gray-200 bg-white overflow-hidden">
                {state.kind === 'building' && (
                    <div className="flex items-center justify-center h-full">
                        <div className="flex flex-col items-center gap-2">
                            <div className="w-6 h-6 rounded-full border-2 border-gray-300 border-t-gray-800 animate-spin" />
                            <div className="text-xs text-gray-500">Building Dx report PDF…</div>
                        </div>
                    </div>
                )}
                {state.kind === 'error' && (
                    <div className="flex items-center justify-center h-full p-4">
                        <div className="flex flex-col items-center gap-2 text-center max-w-md">
                            <ExclamationCircleIcon className="w-6 h-6 text-red-500" />
                            <div className="text-xs text-red-500">{state.message}</div>
                            {onBackToEdit && (
                                <button
                                    onClick={onBackToEdit}
                                    className="mt-2 text-xs font-medium text-gray-700 underline"
                                >
                                    Back to editor
                                </button>
                            )}
                        </div>
                    </div>
                )}
                {state.kind === 'ready' && (
                    <iframe
                        src={state.url}
                        title="Dx report PDF preview"
                        className="w-full h-full"
                        style={{ border: 'none' }}
                    />
                )}
            </div>
        </div>
    );
}
